export class FileNotFoundInZipError extends Error {
  constructor(message) {
    super(message);
    this.name = 'FileNotFoundInZipError';
  }
}
